import { formatDateString } from '~/utils/date';

export const formatDate = (dateString: string) => {
    return formatDateString(dateString) ?? 'Invalid Date';
};

export const formatReviewDateTime = (
    reviewDate?: string,
    reviewTime?: string
): string => {
    if (!reviewDate || reviewDate.length !== 8) {
        return '-';
    }

    const datePart = formatDateString(reviewDate) ?? '-';

    if (!reviewTime || reviewTime.length < 4) {
        return datePart;
    }

    const hours = reviewTime.slice(0, 2);
    const minutes = reviewTime.slice(2, 4);

    return `${datePart} ${hours}:${minutes}`;
};
